module.exports = __webpack_public_path__ + "static/media/4 knee ex.73daaa9a.png";